import React from 'react';
import { Button, Form, Input, Select } from 'antd';

//mobx
import { useStore } from '@/store';
import { observer } from 'mobx-react-lite';
import { set, runInAction, toJS } from 'mobx';



const App = () => {
    //mobx
    const { VideoStore } = useStore()
    // 取消按钮
    const [form] = Form.useForm();
    const { Option } = Select



    //表单提交
    const onFinish = async (values) => {
        if (values.aigreenhouse_name) {
            let a = []
            a = values.aigreenhouse_name.split(',')
            values.aigreenhouse_id = a[0]
            values.aigreenhouse_name = a[1]
        }
        await VideoStore.getAddSheds(values)
        runInAction(() => {
            set(VideoStore, { isAshow: false })
            set(VideoStore, { selectdata: [] })
        })
    };

    //表单取消
    const onReset = () => {
        form.resetFields();
        runInAction(() => {
            set(VideoStore, { isAshow: false })
            set(VideoStore, { selectdata: [] })
        })
    };


    return (
        <>
            <Form
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 14,
                }}
                form={form}
                onFinish={onFinish}
            >
                <Form.Item
                    label="棚室"
                    name="aigreenhouse_name"
                    rules={[
                        {
                            required: true,
                            message: '请选择棚室',
                        },
                    ]}
                >
                    <Select
                        placeholder="请选择设备名称"
                        style={{ width: '180px' }}
                    >
                        {
                            VideoStore.selectdata && (
                                toJS(VideoStore.selectdata).map((item) => {
                                    return <Option value={item.value} key={item.value}>{item.label}</Option>
                                })
                            )
                        }
                    </Select>
                </Form.Item>
                <Form.Item
                    label="视频地址"
                    name="video_url"
                    rules={[
                        {
                            required: true,
                            message: '请输入正确视频地址'
                        }
                    ]}
                >
                    <Input placeholder="只能输入英文" />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 6 }}>
                    <Button type="primary" htmlType="submit">
                        提交
                    </Button>
                    <Button htmlType="button" onClick={onReset} style={{ marginLeft: '15px' }}>
                        取消
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}
export default observer(App)